/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetDiscoveryRequest} from '@cash-web/protos/squareup/cash/marketdata/server/market_data_service.pb'
import {GetDiscoveryResponse} from '@cash-web/protos/squareup/cash/marketdata/server/market_data_service.pb'


export const getDiscoveryServer = (request:GetDiscoveryRequest, options?: CashRequestOptions) => post<GetDiscoveryRequest, GetDiscoveryResponse>("/2.0/cash/get-discovery-server", request, {...options, rejectOnError: true })